import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import { notification } from "antd";
import {
	GET_BOT_FLOW,
	SET_NODE,
	SHOW_LOADING,
	SET_BOT_FLOW,
	GET_BOT_ACCOUNTS,
	GET_BOT_FLOW_TEMPLATES,
	SEND_BOT_FLOW_SKILL,
	GET_BOT_INTREGATIONS,
} from "../constants/BotFlow";

import {
	setNode,
	getBotFlow,
	showLoading,
	setBotAccounts,
	saveBotAccounts,
	setBotFlowTemplates,
	saveBotIntegrations,
} from "../actions/BotFlow";
import ApiService from "../../Services/ApiService";
import { toastNotification } from "../../utils/toastNotification";

function* fetchBotFlow() {
	yield takeEvery(GET_BOT_FLOW, function* () {
		try {
			yield put(showLoading(true));
			const res = yield ApiService.get("/hulk/api/v1/getBotFlow");
			yield put(setNode(res));
			yield put(showLoading(false));
		} catch (err) {
			//   yield put(authStatus(false));
		}
	});
	yield takeEvery(SET_BOT_FLOW, function* (action) {
		try {
			const res = yield ApiService.post(`/hulk/api/v1/updateBot?publish=${action.payload.publish ? "yes" : "no"}`, {}, action.payload.nodes);
			yield put(setNode(action.payload.nodes));
			notification.success({
				message: !action.payload.publish ? "Flow Updated successfully" : "Flow updated and published successfully",
			});
		} catch (err) {
			//   yield put(authStatus(false));
		}
	});

	yield takeEvery(GET_BOT_ACCOUNTS, function* () {
		try {
			const res2 = yield ApiService.get("/hulk/api/v1/bot-accounts");
			let stateVal = {};
			if (res2.data) {
				res2.data.map((acc) => {
					stateVal[acc.channel] = {
						entityId: acc.entity_id,
						is_test: acc.is_test,
					};
				});
			}
			yield put(setBotAccounts(stateVal));
			yield put(saveBotAccounts(res2.data));
		} catch (err) {
			//   yield put(authStatus(false));
			// toastNotification({errorMessage:"Internal Server Error"});
		}
	});
}

export function* getBotFlowTemplates() {
	yield takeEvery(GET_BOT_FLOW_TEMPLATES, function* (action) {
		try {
			const res = yield ApiService.get(`/hulk/api/v1/template-groups-custom`);
			if (res && res.status == "success") {
				yield put(setBotFlowTemplates(res.data));
			}
		} catch (error) {
			console.error(error);
			// toastNotification({ res: null, errorMessage: "Unable to fetch botflow templates" });
		}
	});
}
export function* sendBotflowSkill() {
	yield takeEvery(SEND_BOT_FLOW_SKILL, function* (action) {
		console.log("payloaad", action.payload);
		try {
			const res = yield ApiService.post(`/hulk/api/v1/template_skill`, {}, action.payload);
			if (res && res.status == "success") {
				yield put(getBotFlow());
				toastNotification({ res });
			} else {
				toastNotification({ res: null, errorMessage: res.message });
			}
		} catch (error) {
			console.log(error);
			toastNotification({ res: null, errorMessage: "Unable import skill" });
		}
	});
}
export function* getBotIntegrations() {
	yield takeEvery(GET_BOT_INTREGATIONS, function* (action) {
		console.log("payloaad", action.payload);
		try {
			const res = yield ApiService.get(`/hulk/api/v1/installed-apps`);
			if (res && res.status === "success") {
				yield put(saveBotIntegrations(res.data));
			} else {
				toastNotification({ res: null, errorMessage: res.message });
			}
		} catch (error) {
			console.log(error);
			toastNotification({ res: null, errorMessage: "Unable to fetch bot integrations" });
		}
	});
}


export default function* rootSaga() {
	// console.log("ROOT SAGA CALLED");
	yield all([
		fetchBotFlow(),
		getBotFlowTemplates(),
		sendBotflowSkill(),
		getBotIntegrations(),
	]);
}
